const inputViewTimeActions = {
  placeholder: 'Escreva aqui...'
};

export default inputViewTimeActions;
